import { render } from "./TSMCreateCheck.vue?vue&type=template&id=4fd7c6fa"
import script from "./TSMCreateCheck.vue?vue&type=script&lang=js"
export * from "./TSMCreateCheck.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__